import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import { LeadForm } from 'sections/Benefits/components/LeadForm';
import styles from 'styles/pages/Benefits/ShippingLeads/ShippingLeads.module.scss';

const cn = classNames.bind(styles);

type SectionFormProps = {
  pageTitle?: string;
  formUrl?: string;
  leadSubtype?: string;
}

const SectionForm: FC<SectionFormProps> = ({ pageTitle, formUrl, leadSubtype }: SectionFormProps): ReactElement => {
  return (
    <section className={cn('form')}>
      <div className={cn('container')}>
        <div className={cn('form__title-box')}>
          <h2 className={cn('form__title')}>
            Unlock Your Shipping Leads Today – Start Connecting Now!
          </h2>
          <p className={cn('form__title-description')}>
            Sign up and start receiving real-time shipping leads that match your business needs. It's quick and easy to get started!
          </p>
        </div>
        <div className={cn('form__content-box')}>
          <ul className={cn('form__content-list')}>
            <li className={cn('form__content-list-item')}>
              Instant Access to New Business: Gain direct access to qualified shipping leads f
              rom around the globe —delivered straight to you
            </li>
            <li className={cn('form__content-list-item')}>
              Tailored Matches: Our smart algorithms ensure you receive leads that align
              with your specific services and locations
            </li>
            <li className={cn('form__content-list-item')}>
              Real-Time Opportunities: Be the first to respond to shipping requests and gain an
              edge over your competitors with our real-time bidding
            </li>
            <li className={cn('form__content-list-item')}>
              Increase Sales Efficiency: Streamline your sales process with fewer cold calls and more
              actionable leads
            </li>
            <li className={cn('form__content-list-item')}>
              Build Long-Term Relationships: Secure recurring business by establishing trust with clients
              and offering competitive solutions
            </li>
          </ul>
          <LeadForm
            pageTitle={pageTitle ?? ''}
            formUrl={formUrl ?? ''}
            leadSubtype={leadSubtype ?? ''}
            formClassNames={{
              container: cn('lead-form'),
              formElements: cn('lead-form__form-elements'),
              buttons: cn('lead-form__buttons'),
              button: cn('lead-form__button'),
              preloader: cn('lead-form__preloader'),
            }}
            inputClassNames={{
              container: cn('input'),
              labelText: cn('input__label-text'),
              input: cn('input__input'),
            }}
            selectClassNames={{
              selectPanel: cn('phone__select-panel'),
              selectPanelPhone: cn('phone__select-panel--phone'),
              selectPanelNumber: cn('phone__select-panel-number--fill'),
              selectInput: cn('phone__select-input'),
              inputLabel: cn('phone__input-label'),
              input: cn('phone__input'),
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default SectionForm;